import { render, staticRenderFns } from "./DepositExternalInfo.vue?vue&type=template&id=46cc8316"
import script from "./DepositExternalInfo.vue?vue&type=script&lang=js"
export * from "./DepositExternalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports